module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Terminal-ddd99854ad4eb707d0a67f6017c860b1.svg";